module.exports = __webpack_public_path__ + "static/media/reset-insta.0eb59863.svg";